export default __webpack_public_path__ + "static/media/no_image.c9237fcb.png";